module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#trending",
      toString: function () {
        return this.url;
      }
    }